import script from "./LiquidityChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiquidityChart.vue?vue&type=script&setup=true&lang=ts"

import "./LiquidityChart.vue?vue&type=style&index=0&id=07315485&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07315485"],['__file',"LiquidityChart.vue"]])

export default __exports__